import { Box, Paper } from "@mui/material"
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab'
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import InEligibleGrid from "./InEligible";
import EPFOLandingPage from "./EPFOLandingPage";
import MyEmployeeTaxReport from "./MyEmployeeTaxReport";
import PaySlipLandingPage from "./PaySlip/PaySlipLandingPage";
import AttendanceSummaryReport from "./AttendanceSummaryReport";
import { useDispatch } from "react-redux";
import { GetAccessWorkLocationAction } from "../../../../../store/Ancillary/WorkLocation/Action";

const EmployeeTimeLandingPage = () => {
    const location = useLocation();
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        if (location?.state?.activeTab !== undefined) {
            setValue(location.state.activeTab);
        }
    }, [location]);

    useEffect(() => {
        dispatch(GetAccessWorkLocationAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
            <Box sx={{ minHeight: "calc(100vh - 65px)",
                        maxHeight: "calc(100vh - 65px)", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    sx={{mb: 1}}
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    >
                    <Tab label="Payroll Onhold Employees" {...a11yProps(0)} />
                    <Tab label="Attendance Summary" {...a11yProps(1)} />
                    <Tab label="PaySlip" {...a11yProps(2)} />
                    <Tab label="Tax Report" {...a11yProps(3)} />
                    <Tab label="EPFO ECR" {...a11yProps(4)} />
                </Tabs>

                <TabPanel value={value} index={0}>
                    <InEligibleGrid />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <AttendanceSummaryReport />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <PaySlipLandingPage />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <MyEmployeeTaxReport />
                </TabPanel>
                <TabPanel value={value} index={4} >
                    <EPFOLandingPage />
                </TabPanel>
            </Box>
        </Base>
    )
}

export default EmployeeTimeLandingPage;